import { render, staticRenderFns } from "./MonthsPage.vue?vue&type=template&id=6a6a41e2&scoped=true"
import script from "./MonthsPage.vue?vue&type=script&lang=js"
export * from "./MonthsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6a41e2",
  null
  
)

export default component.exports